import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgxDatatableModule } from '@siemens/ngx-datatable';


import { TemplatedetailPage } from './templatedetail.page';
import { NgxPopperModule } from 'ngx-popper';

const routes: Routes = [
  {
    path: '',
    component: TemplatedetailPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    NgxDatatableModule,
    NgxPopperModule.forRoot({placement: 'bottom', trigger: 'hover', appendTo: 'body', applyClass: 'tooltip'}),
    RouterModule.forChild(routes)
  ],
  declarations: [TemplatedetailPage]
})
export class TemplatedetailPageModule {}
